import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import LocalStorageService, {
  LocalStorageKey,
} from '@shared/services/local-storage.service';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localePl from '@angular/common/locales/pl';
import localeUk from '@angular/common/locales/uk';
import { Locals } from 'express';

@Injectable({
  providedIn: 'root',
})
export class DatePipeLocaleService {
  private readonly localeMap: Record<string, string> = {
    en: 'en-US',
    pl: 'pl',
    ua: 'uk',
  };

  private translateService = inject(TranslateService);
  private localStorageService = inject(LocalStorageService);

  /**
   * Initialize Luxon locale based on current user language
   */
  public initializeLocale(): void {
    // Set global locale
    registerLocaleData(localeUk);

    // Listen for language changes
    this.translateService.onLangChange.subscribe((event) => {
      this.localStorageService.setItem(LocalStorageKey.UI_LANGUAGE, event.lang);
      registerLocaleData(this.getLocale(event.lang));
    });
  }

  /**
   * Get locale code from app language code
   */
  private getLocale(language: string | null): Locals {
    if (!language) {
      return localeEn;
    }

    switch (language) {
      case 'en':
        registerLocaleData(localeEn);
        break;
      case 'pl':
        registerLocaleData(localePl);
        break;
      case 'ua':
        registerLocaleData(localeUk);
        break;
      default:
        registerLocaleData(localeEn);
    }

    return this.localeMap[language] || 'en-US';
  }
}
